export const deleteAllCookies = () => {
  let cookies = document.cookie.split("; ");
  for (const i in cookies) {
    document.cookie =
      /^[^=]+/.exec(cookies[i])[0] + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT";
  }
};
